var _ = require("../../../uam/module.js")(module.exports, {
  namespace: "ua.preview.address",
  title: "Control Preview: Address",
  description: "Read-only preview renderer for ua.address values.",
  fields: {
    "value": { title: "Value", type: "*", description: "Address value object or text." }
  }
});

var helper = require("./helpers/control.preview.js");

function asLines(value) {
  if (typeof value === "string") {
    return value.split(/\n+/g).map(function(line) {
      return line.trim();
    }).filter(function(line) {
      return line.length > 0;
    });
  }

  if (!(value && typeof value === "object")) {
    return [];
  }

  var line1 = value.line1 || value.address1 || value.address || "";
  var line2 = value.line2 || value.address2 || "";
  var city = value.city || "";
  var state = value.state || value.province || value.region || "";
  var zip = value.zip || value.postal || value.postalCode || "";
  var country = value.country || "";

  var cityRow = [city, state, zip].filter(function(part) {
    return !!(part || "").toString().trim();
  }).join(", ").replace(/,\s+,/g, ", ");

  return [line1, line2, cityRow, country].filter(function(part) {
    return !!(part || "").toString().trim();
  });
}

exports.render = async function(options) {
  var lines = asLines(options.value);
  return helper.renderDoc(helper.jsonLines(lines, "ua-control-preview-address"));
};

/* Plain-text twin of render() for non-DOM surfaces (emails, logs, exports):
 * the same readable value, as a string. "" means nothing to show. */
exports.toText = function(options) {
  return asLines((options || {}).value).join("\n");
};
